import { render } from "./MemberLayout.vue?vue&type=template&id=4dd1895c"
import script from "./MemberLayout.vue?vue&type=script&lang=js"
export * from "./MemberLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__